import React, { Component } from 'react';

class Page extends Component {
  render() {
    return (
      <>
        <div className="homepage">
          <div className="container">
            <div className="row">
              <div className="col-12">404 Error</div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default Page;